import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Show the first tab by default
    this.showTab(0)
  }

  switch(event) {
    event.preventDefault()
    const tabIndex = this.tabTargets.indexOf(event.currentTarget)
    this.showTab(tabIndex)
  }

  showTab(index) {
    // Hide all panels
    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove("hidden")
        panel.classList.add("block")
      } else {
        panel.classList.add("hidden")
        panel.classList.remove("block")
      }
    })

    // Update tab states
    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        // Active tab styling
        tab.classList.add("border-sky-500", "text-sky-600")
        tab.classList.remove("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300")
        tab.setAttribute("aria-selected", "true")
      } else {
        // Inactive tab styling
        tab.classList.remove("border-sky-500", "text-sky-600")
        tab.classList.add("border-transparent", "text-gray-500", "hover:text-gray-700", "hover:border-gray-300")
        tab.setAttribute("aria-selected", "false")
      }
    })
  }
}